import type { NavItem } from '@/types/shared';

export const navigation: NavItem[] = [
  {
    label: 'Memberships',
    ariaLabel: 'Explore Sollis Health membership options',
    children: [
      {
        label: 'Signature',
        href: '/membership',
        ariaLabel: 'Learn about the Signature membership',
      },
      {
        label: 'Platinum',
        href: '/platinum',
        ariaLabel: 'Learn about the Platinum membership',
      },
      {
        label: 'Pediatrics',
        href: '/pediatrics',
        ariaLabel: 'Learn about Sollis Health pediatric services',
      },
      {
        label: 'For Members',
        href: '/for-members',
        ariaLabel: 'Manage your Sollis Health membership and account',
      },
    ],
  },
  {
    label: 'Locations',
    href: '/locations',
    ariaLabel: 'Find Sollis Health medical centers near you',
  },
  {
    label: 'Meet our team',
    href: '/medical-team',
    ariaLabel:
      'Learn about our qualified medical professionals and their specialties',
  },
  {
    label: 'FAQs',
    href: '/faqs',
    ariaLabel: 'Common questions about Sollis Health services',
  },
  {
    label: 'For doctors',
    href: '/for-doctors',
    ariaLabel:
      'Information for medical professionals interested in joining Sollis Health',
  },
  {
    label: 'For businesses',
    href: '/for-companies',
    ariaLabel: 'Corporate healthcare solutions and partnership opportunities',
  },
  {
    label: 'Contact us',
    href: '/contact-us',
    ariaLabel: 'Get in touch with Sollis Health',
  },
  {
    label: 'Join Now',
    href: '/intake-v2/signup-type',
    variant: 'dark',
    pinned: true,
    ariaLabel: 'Sign up for Sollis Health membership',
  },
];
